var r = ((r2) => (r2.vitePreloadError = "vite:preloadError", r2.LoadingStateEvent = "loadingStateEvent", r2.InternalServerErrorEvent = "internalServerErrorEvent", r2))(r || {});
export {
  r as AppEvents
};
//# sourceMappingURL=eventMap.js.map
